import React from 'react'
import { assets } from '@/helpers/common'
import Promotion from '@/components/sections/Promotion'
import { PrimaryBanner } from '@/v1/components/ui/banner'
import { BANNERS } from '@/v1/components/ui/banner/constant'
import FeatureBox from '@/components/subComponents/FeatureBox'

const features = [
  {
    title: 'You Order',
    icon: assets('images/location-box-storage/you-order.png'),
    content:
      'You have customized option for shipment. Either you can order single luggage or boxes or as much as you want.'
  },
  {
    title: 'We Ship',
    icon: assets('images/location-box-storage/we-ship.png'),
    content:
      'No matter how much luggage or boxes you ordered or wherever you are! We can ship any quantity, anywhere, and make sure convenient shipping.'
  }
]

const features_two = [
  {
    title: 'Prohibited Items',
    icon: assets('images/location-box-storage/feature-01.png'),
    content:
      'Aerosol, sprays, perfumes, or other pressurized containers, alcohol, tobacco, perishable food, medication (including vitamins), batteries (included with personal device) or any items specified in our Terms and Conditions or Restricted Items list.'
  },
  {
    title: 'Items Not Covered by Insurance',
    icon: assets('images/location-box-storage/feature-02.png'),
    content:
      'Fragile items, jewelry, antiques, collector’s items, electronics Items, camera equipment, precious metal and gems, valuables, art Items, and any cosmetic damage and tear on luggage or any Items specified in our Terms and Conditions.'
  },
  {
    title: 'Labeling',
    icon: assets('images/location-box-storage/feature-03.png'),
    content:
      'To ensure secure shipping, insert shipping labels inside label pouch with the tracking barcode facing outside. <br/> <br/> Stick the pouch tightly to a luggage tag and secure the tag to the top handle of your bag. Place an additional copy of label inside your bag or on your box with clear tape.'
  },
  {
    title: 'Hotel Pickup and Delivery Instructions',
    icon: assets('images/location-box-storage/feature-04.png'),
    content:
      "Always check with hotel if they can accept or ship out package on behalf of you, as well as the preferred pick up or delivery time frame and location. When booking your hotel stay, please provide all necessary details in the 'notes' section. This includes your check-in date, room number, hotel contact person, and pick-up/delivery location. Please timely inform hotel the pickup or delivery information once we send you the shipping document."
  }
]

const features_output = features.map((item, index) => {
  return (
    <div key={index} className='w-6/12 xs:w-full px-6 text-center'>
      <FeatureBox className='style-six' title={item.title} icon={item.icon} content={item.content} />
    </div>
  )
})

const features_two_output = features_two.map((item, index) => {
  return (
    <div key={index} className='w-5/12 md-mx:w-6/12 xs:w-full mb-8 md-mx:mb-4 md-mx:px-3 text-center'>
      <FeatureBox className='style-six' title={item.title} icon={item.icon} content={item.content} />
    </div>
  )
})

const LuggageBoxShippingServices = () => {
  return (
    <>
      <PrimaryBanner info={BANNERS.luggageBoxShippingServices} />

      <section className='why-you-need-section pt-20 pb-24 md-mx:pt-10 sm-mx:pt-10 sm-mx:pb-6'>
        <div className='container'>
          <div className='row justify-center pb-6 lg-mn:pb-10'>
            <div className='w-full text-center'>
              <div className='section-title effect text-center'>
                <h2 className='inline-block mx-auto max-w-[750px] xs:text-lg'>
                  From our warehouse you can ship your luggage and boxes in just two easy steps!
                </h2>
              </div>
            </div>
          </div>

          <div className='row justify-around'>{[features_output]}</div>
        </div>
      </section>

      <section className='our-specialty-section bg-white-ice pt-10 pb-24 sm-mx:pb-10'>
        <div className='container'>
          <div className='row justify-center'>
            <div className='w-full text-center'>
              <div className='section-title effect text-center'>
                <h2 className='inline-block'>Our Specialties</h2>
              </div>
            </div>
          </div>
          <div className='row mt-14 sm-mx:mt-6'>
            <div className='w-full row justify-center sm-mx:justify-between'>
              <ul className='list-style-one'>
                <li>Real-time tracking</li>
                <li>Free tag shipment</li>
              </ul>
              <ul className='list-style-one'>
                <li>24/7 supporting</li>
                <li>Free storage service</li>
              </ul>
              <ul className='list-style-one'>
                <li>Free insurance up to $250 each</li>
                <li>Shipment protection</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className='why-you-need-section pt-20 md-mx:pt-10 sm-mx:pt-10'>
        <div className='container'>
          <div className='row justify-center'>
            <div className='w-full text-center'>
              <div className='section-title effect text-center'>
                <h2 className='inline-block'>International Luggage Shipping Tips</h2>
                <p className={'mx-auto max-w-[680px]'}>
                  For international shipment, a person has to abide by certain rules. Below are some tips for
                  international shipping:
                </p>
              </div>
            </div>
          </div>
          <div className='row justify-around mt-14'>{[features_two_output]}</div>
        </div>
      </section>
      <Promotion />
    </>
  )
}

export { LuggageBoxShippingServices }
